/* radix parameter for parseInt function */
export const DECIMAL_RADIX = 10;

export const REGEX_NON_NEGATIVE_INTEGER = /^([1-9]\d*|0)$/;

export const SCANNABLE_ID_REGEX = /^([a-zA-Z0-9_-]+\.){2}[a-zA-Z0-9_-]+$/;

export const MANUAL_CYCLE_COUNT_REASON_LIMIT = 400;

/* cycle work request once started will automatically return to pending state after specified hours */
export const CYCLE_COUNT_WORK_REQUEST_EXPIRY = { hours: 6 };

export const RECEIVE_EXCEPTION_NOTE_MAX_LENGTH = 10000;
